const colors = {
  black: "#000000",
  white: "#ffffff",
  yellow: "#FEC601",
  greenBright: "#6CF1B4",
  greenDull: "#5EDEA3",
  blueBright: "#3779E4",
  blueDull: "#1A5CC6",
  orangeBright: "#EC6239",
  orangeDull: "#D34920",
  greenBright2: "#55BB78",
  greenDull2: "#4A9E67",
  purpleBright: "#4F3EDF",
  purpleDull: "#3928C7",
  purple2Bright: "#3521A8",
  purple2Dull: "#4B3AD4",
  buttonBlue: "#0972B4",
}

export const colorMapping = [
  {
    primary: colors.greenBright,
    secondary: colors.greenDull,
    heading: colors.black,
  },
  {
    primary: colors.blueBright,
    secondary: colors.blueDull,
    heading: colors.white,
  },
  {
    primary: colors.orangeBright,
    secondary: colors.orangeDull,
    heading: colors.white,
  },
  {
    primary: colors.greenBright2,
    secondary: colors.greenDull2,
    heading: colors.white,
  },
  {
    primary: colors.purpleBright,
    secondary: colors.purpleDull,
    heading: colors.white,
  },
]

export const NO_OF_COLORS = colorMapping.length

export default colors
